import type { ApiConfig, FetchApiData, FetchSubTypes } from '../types'
import { depositHistoryApiConfig } from './depositHistory/constants'
import { fetchApiData as fetchDepositHistoryApiData } from './depositHistory/fetchApiData'
import { spotTaxHistoryApiConfig } from './spotTaxHistory/constants'
import { fetchApiData as fetchSpotTaxHistoryApiData } from './spotTaxHistory/fetchApiData'
import { withdrawalHistoryApiConfig } from './withdrawalHistory/constants'
import { fetchApiData as fetchWithdrawalHistoryApiData } from './withdrawalHistory/fetchApiData'

export const bitgetApiConfigs = {
  [depositHistoryApiConfig.type]: depositHistoryApiConfig,
  [spotTaxHistoryApiConfig.type]: spotTaxHistoryApiConfig,
  [withdrawalHistoryApiConfig.type]: withdrawalHistoryApiConfig,
} as const satisfies Record<string, ApiConfig>

export type BitgetApiType = keyof typeof bitgetApiConfigs

export const bitgetApiTypes = Object.keys(bitgetApiConfigs) as BitgetApiType[]

export const fetchBitgetApiDataFuncs = {
  [depositHistoryApiConfig.type]: fetchDepositHistoryApiData,
  [spotTaxHistoryApiConfig.type]: fetchSpotTaxHistoryApiData,
  [withdrawalHistoryApiConfig.type]: fetchWithdrawalHistoryApiData,
} as const satisfies Record<string, FetchApiData>

export const fetchBitgetSubTypesFuncs = {
  [depositHistoryApiConfig.type]: undefined,
  [spotTaxHistoryApiConfig.type]: undefined,
  [withdrawalHistoryApiConfig.type]: undefined,
} as const satisfies Record<string, FetchSubTypes | undefined>

export { getCurrentBitgetAssets } from './getCurrentAsset'
